








































































import Vue from 'vue'
import UserStatsList from '../components/UserStatsList.vue'
import UserStatsEditForm from '../components/UserStatsEditForm.vue'
import AppDialogConfirm from '@morpheus/utils/admin-vue/components/AppDialogConfirm.vue'
import { StatsData, StatsEditData } from '../types'
import { fetchStatsListByUserId, updateUserStats, dropStatsByUserId } from '../services/stats-client'

export default Vue.extend({
  name: 'UserStats',
  components: {
    UserStatsList,
    UserStatsEditForm,
    AppDialogConfirm
  },
  props: {
    userId: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      isLoading: true,
      showEditStatsForm: false,
      headers: [
        { text: 'Code', value: 'code', sortable: false },
        { text: 'Value', value: 'value', sortable: false }
      ],
      itemsList: [],
      itemsTotal: 0,
      clearEditForm: false,
      showConfirmDialog: false,
      dialogMessage: 'Are you sure you want to drop stats for this user?'
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchStatsListByUserId(this.userId)
        .then((stats) => {
          this.itemsList = []
          stats.forEach((item: StatsData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
        })
        .catch((error: any) => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
          this.$store.commit('global/setLoading', false)
        })
    },
    onSubmit (requestObj: StatsEditData) {
      updateUserStats(requestObj, this.userId)
        .then(() => {
          this.clearEditForm = true
          this.fetchItems()
          this.$store.commit('global/addNotification', {
            text: 'You successfully edit stat!',
            type: 'success'
          })
        })
        .catch((error:any) => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
    },
    closeDialog () {
      this.clearEditForm = false
      this.showEditStatsForm = false
    },
    confirmDrop (confirm: boolean) {
      this.showConfirmDialog = false

      if (confirm) {
        this.isLoading = true

        dropStatsByUserId(this.userId)
          .then((stats) => {
            this.$store.commit('global/addNotification', {
              text: 'You successfully dropped user stats!',
              type: 'success'
            })
          })
          .catch((error: any) => {
            this.isLoading = false
            this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
          })
          .finally(() => {
            // fixme! temporary solution as we get 404 from server after successful drop
            this.fetchItems()
          })
      }
    }
  }
})
